module.exports = __webpack_public_path__ + "static/img/bgImage4.4517868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technicalAdvantages/tab1/wap/bgImage4.jpg
// module id = er4h
// module chunks = 0